import { useAtom } from 'jotai'
import { useCallback } from 'react'

import { downloadAtom } from 'atoms/downloads.atom'

export const useDownloadFile = () => {
  const [, setDownload] = useAtom(downloadAtom)
  const downloadFile = useCallback(
    (url: string | URL | Request, filename: string) => {
      setDownload(true)
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok')
          return response.blob()
        })
        .then(blob => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename || 'download'
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          console.error('Download failed:', error)
        })
        .finally(() => {
          setDownload(false)
        })
    },
    [setDownload],
  )

  return downloadFile
}
